import { Stack, Text, Box } from '@ltvco/refresh-lib/theme';
import { usePhoneFormatter } from '@ltvco/refresh-lib/utils';
import { useMemo } from 'react';

import { EmailSummaryData } from '../DataTypes/SummaryTypes';

import { BoldSpan } from './components';

interface EmailReportRendererProps {
  data: EmailSummaryData;
}

const formatFraudScore = (fraudScore: number | undefined): string => {
  if (fraudScore === undefined || fraudScore === null) {
    return 'N/A';
  }

  let riskLevel: string;
  if (fraudScore >= 90) {
    riskLevel = '🔴 High';
  } else if (fraudScore >= 75) {
    riskLevel = '🟡 Medium';
  } else if (fraudScore >= 50) {
    riskLevel = '🟢 Low';
  } else {
    riskLevel = '🟢 Very Low';
  }

  return `${riskLevel} fraud risk`;
};

export const EmailReportRenderer = ({ data }: EmailReportRendererProps) => {
  const formattedPhoneNumber = usePhoneFormatter(data.owner_phone, true);
  const formattedFraudScore = useMemo(
    () => formatFraudScore(data.fraud_score),
    [data.fraud_score]
  );
  return (
    <Stack spacing={2}>
      {data.email && (
        <Text variant="body1">
          We found 1 record for: <BoldSpan>{data.email}</BoldSpan>
        </Text>
      )}
      <Stack spacing={1.5}>
        <Box>
          <Text variant="body1" sx={{ fontWeight: 700, mb: 1 }}>
            Email Info:
          </Text>
          <Text variant="body1">
            <BoldSpan>Email Type:</BoldSpan> {data.email_type || 'Personal'}
          </Text>
          <Text variant="body1">
            <BoldSpan>FraudScan Score:</BoldSpan> {formattedFraudScore}
          </Text>
        </Box>

        <Box>
          <Text variant="body1" sx={{ fontWeight: 700, mb: 1 }}>
            Owner:
          </Text>
          <Text variant="body1">
            <BoldSpan>Name:</BoldSpan> {data.owner_name || 'N/A'}
          </Text>
          <Text variant="body1">
            <BoldSpan>Phone:</BoldSpan> {formattedPhoneNumber || 'N/A'}
          </Text>
          <Text variant="body1">
            <BoldSpan>Address:</BoldSpan> {data.owner_address || 'N/A'}
          </Text>
        </Box>
      </Stack>
    </Stack>
  );
};
